import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'shortenName'
})
export class FormatFirstNameLastLetterPipe implements PipeTransform {
    transform(firstName: string = '', lastName: string | null | undefined = ''): string {
        if (!firstName && !lastName) return '';

        if (!!firstName && !lastName) return firstName;

        if (!firstName && !!lastName) return lastName[0] + '.';

        return firstName + ' ' + lastName?.[0] + '.';
    }
}
